
import { RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { LoaderService } from "../../common/services/loader.service";
import { tap } from "rxjs/operators";
import { Well } from "../../common/models/well.model";
import { WellService } from "../../common/services/well.service";

@Injectable()
export class WellResolver  {
    constructor(
        public _wellService: WellService,
        public _loader: LoaderService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Well> {
        this._loader.toggleLoader(true);
        return this._wellService.getWellById(route.params.id).pipe(tap(() => {
            this._loader.toggleLoader(false);
        }));
    }
}